import prefix from 'modules/utils/prefix'
import { Language } from './models'
import { createAction } from '@reduxjs/toolkit'

export const namespaced = prefix('users/users')

export const CHANGE_LANGUAGE = namespaced('changeLanguage')
export const changeLanguage = createAction<Language>(CHANGE_LANGUAGE)
